import Animated from "react-native-reanimated";
import { Flex } from "ui/src/components/layout/Flex";
export const AnimatedFlex = Animated.createAnimatedComponent(Flex);
AnimatedFlex.displayName = "AnimatedFlex";
